<template>
    <div class="paragraph-block" v-if="!preview">
        <div class="d-flex justify-space-between align-center mb-2">
            <span class="paragraph-label">{{$t('esgPlatform.esgReport.paragraph')}}</span>
            <div class="d-flex align-center">
                <v-btn icon color="primary" @click="showSettings = true">
                    <v-icon>mdi-cog</v-icon>
                </v-btn>
                <v-btn icon color="error" class="ml-2" @click="$emit('delete')">
                    <v-icon>mdi-trash-can</v-icon>
                </v-btn>
            </div>
        </div>
        <div class="editor-wrapper" :style="wrapperStyles">
            <quill-editor v-model="content" :options="editorOptions" @blur="emitContent"/>
        </div>
        <ComponentSettingsDialog  v-model="showSettings"  :settings="currentSettings"  @save="handleSaveSettings" />
    </div>
    <div v-else class="preview-paragraph" :style="previewStyles" v-html="safePreviewContent"></div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import ComponentSettingsDialog from '../ComponentSettingDialog.vue';
import Quill from 'quill';
Quill.register(Quill.import("attributors/style/align"), true);

export default {
    name: 'ParagraphBlock',
    components: { "quill-editor": quillEditor, ComponentSettingsDialog },
    props: {
        block: {
            type: Object,
            required: true
        },
        preview: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showSettings: false,
            content: (this.block && this.block.content) || "",
            editorOptions: {
                theme: "snow",
                placeholder: "Start typing...",
                modules: {
                    toolbar: [
                        [{ font: [] }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        ["bold", "italic", "underline", "strike"],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link", "image"],
                        ["clean"]
                    ]
                }
            }
        };
    },
    computed: {
        currentSettings() {
            return {
                bgColor: '#ffffff',
                fontColor: '#101010',
                font: 'Poppins',
                ...(this.block?.settings || {})
            };
        },
        wrapperStyles() {
            return { backgroundColor: this.currentSettings.bgColor,
                color: this.currentSettings.fontColor,
            };
        },
        previewStyles() {
            return {
                backgroundColor: this.currentSettings.bgColor,
                color: this.currentSettings.fontColor,
                fontFamily: this.currentSettings.font,
                padding: '16px'
            }
        },
        safePreviewContent() {
            return this.block?.content || "";
        }
    },
    watch: {
        "block.content"(val) {
            if (val !== this.content) {
                this.content = val || "";
            }
        }
    },
    methods: {
        emitContent() {
            this.$emit("update", {
                ...(this.block || {}),
                content: this.content || ""
            });
        },
        handleSaveSettings(newSettings) {
            this.$emit("update", {
                ...(this.block || {}),
                settings: newSettings || {}
            });
        }
    },
}
</script>

<style scoped>
.paragraph-block {
    background: #fafbfc;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 16px;
    position: relative;
    border: 1px solid #ddd;
}

.paragraph-label {
    font-size: 18px;
    font-weight: 500;
    color: #222;
}

.editor-wrapper {
    border-radius: 8px;
    background: #fff;
    margin-top: 8px;
    border: 1.5px solid #e0e0e0;
    display: flex;
    flex-direction: column;
}

.preview-paragraph {
    margin-bottom: 16px;
    font-size: 1rem;
    line-height: 1.7;
}

/* Quill deep styles */
:deep(.ql-toolbar.ql-snow) {
    border: none;
    border-bottom: 1px solid #e0e0e0;
    background-color: #f8f9fa;
}

:deep(.ql-container.ql-snow) {
    border: none;
    min-height: 200px;
}

:deep(.ql-editor) {
    min-height: 150px;
    color: inherit !important;
}
</style>